<template>
	<div>
		<myheader :backFlag="!registerFlag" headTitle="注册账号"></myheader>
		<!-- <div v-if="!registerFlag" class="register_content all_content"> -->
		<div v-if="!registerFlag" class="register_content all_content">
			<div class="all_input all_height30" :class="{ isfocus: accountFocus }">
				<van-field v-model="account" type="text" maxlength="30"
					:placeholder="userNames.length>0?'请选择账户名':'请输入账户名'" clearable @focus="getFocus(1)" @blur="onblur(1)"
					:readonly="userNames.length>0" @click="selectAccount()">
				</van-field>
			</div>
			<span class="text12 textcolor33" v-if="!userNames.length>0">英文和数字组合，首字母必须为英文</span>
			<div class="all_input all_height30" :class="{ isfocus: nameFocus }">
				<van-field v-model="staffName" type="text" maxlength="30" placeholder="请输入真实姓名" clearable
					@focus="getFocus(2)" @blur="onblur(2)">
				</van-field>
			</div>
			<span class="text12 textcolor33">真实姓名必须是身份证上的姓名一致</span>
			<div class="all_input all_height30" :class="{ isfocus: emailFocus }">
				<!-- <input class="my_input text14 textcolor333" type="number" placeholder="手机号" v-model="phone"
					@focus="getFocus(1)" @blur="onblur(1)" /> -->
				<van-field v-model="email" type="email" maxlength="30" placeholder="请输入邮箱" clearable
					@focus="getFocus(3)" @blur="onblur(3)">
				</van-field>
			</div>
			<div class="all_input all_height30" :class="{ isfocus: telFocus }">
				<van-field v-model="phone" type="number" maxlength="11" placeholder="请输入手机号" clearable
					@focus="getFocus(4)" @blur="onblur(4)">
				</van-field>
			</div>
			<div v-show="userNames.length===0" class="all_input all_height30" :class="{ isfocus: passwordFocus }">
				<van-field v-model="password" :type="passwordType" maxlength="30" placeholder="请输入登录密码" clearable
					@clear="passwordType = 'password'" @focus="getFocus(5)" @blur="onblur(5)">
					<template v-if="password.length>0" slot="right-icon">
						<img style="width: 20px;object-fit: contain;margin-top: 5px;"
							:src="passwordType==='password'?showPass:hidePass" fill @click="switchPasswordType()">
					</template>
				</van-field>
			</div>
			<span v-show="userNames.length===0" class="text12 textcolor333">不少于8位，区分大小写，需要同时包含数字、字母、特殊字符</span>
			<div class="all_input all_height30" :class="{ isfocus: verifyFocus }">
				<div class="display_inline_block" style="width: 65%">
					<van-field type="number" :placeholder="verifyholder" v-model="verifyCode" @focus="getFocus(6)"
						@blur="onblur(6)" maxlength="6" clearable>
					</van-field>
				</div>
				<span @click="getPictureImg()" class="display_inline_block" title="看不清,换一个" style="width: 30%;">
					<img :src="verifyImg" style="height: 2rem;width: 5rem;" fill title="看不清,换一个" /></span>
			</div>
			<div class="all_input all_height30" :class="{ isfocus: codeFocus }">
				<div class="display_inline_block" style="width: 60%;">
					<van-field v-model="smsCode" type="number" maxlength="6" placeholder="请输入验证码" clearable
						@focus="getFocus(7)" @blur="onblur(7)" @keydown.enter="register()" />
				</div>
				<span @click="getCode()" class="display_inline_block text14 all_text_right all_line_height20"
					style="width: 35%;" :class="{textcolormain:timer===60,textcolor999:timer!=60}">
					{{timer===60?'获取验证码':(timer+'s后再次获取')}}</span>
				<!-- <input class="my_input text14 textcolor333" type="number" placeholder="验证码" v-model="smsCode"
					@focus="getFocus(4)" @blur="onblur(4)" />
				<span class="my_span" v-show="timer == 60" @click="getCode()">获取验证码</span>
				<span class="my_span" v-show="timer != 60">{{ timer }}s后再次获取</span> -->
			</div>
			<button class="all_button text14 bmain_active" style="margin-top: 1.5rem;"
				@click="registerCheck()">注&nbsp;&nbsp;册</button>
		</div>
		<div v-if="registerFlag" class="register_content all_content all_text_center">
			<img src="@/assets/images/selected.svg" style="width: 4rem;height: 4rem;margin-top: 30%;" />
			<div class="font_weight_900 margin_top_10" style="font-size: 1.4rem;">恭喜您，注册成功</div>
			<!-- <div class="text14 margin_top_10">已发送激活链接到您的注册邮箱</div>
			<div class="text14 margin_top_2" style="width: 80%;margin-left: 10%;">{{email}}, 请进入邮箱对账号进行激活操作，激活后方可登录石化e签。</div> -->
			<button class="all_button text14 bmain_active" style="width: 50%; margin-top: 1.5rem;"
				@click="registerBack()">返回登录页</button>
		</div>
		<van-popup v-model:show="showSelectAccount" round position="bottom">
			<van-picker title="选择账户名" show-toolbar :columns="userNames" @confirm="onPickerConfirm"
				@cancel="onPickerCancel" />
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field,
		Picker
	} from 'vant';
	export default {
		components: {
			[Field.name]: Field,
			[Picker.name]: Picker
		},
		data() {
			return {
				//注册成功   true成功  false失败
				registerFlag: false,
				//是否显示选择账户
				showSelectAccount: false,
				//验证码倒计时
				timer: 60,
				//账号名
				account: '',
				//真实姓名
				staffName: '',
				//邮箱
				email: '',
				//手机号
				phone: '',
				//密码
				password: '',
				//图片验证结果
				verifyCode: '',
				//验证Id
				verifyId: '',
				//验证图片
				verifyImg: '',
				//验证码
				smsCode: '',
				accountFocus: false,
				nameFocus: false,
				emailFocus: false,
				telFocus: false,
				passwordFocus: false,
				codeFocus: false,
				verifyFocus: false,
				//默认显示
				verifyholder: '请输入计算结果',
				//密码可见
				passwordType: 'password',
				//显示
				showPass: require('../../assets/images/show_password.svg'),
				//隐藏
				hidePass: require('../../assets/images/hide_password.svg'),
				userNames: []
			}
		},
		mounted() {
			this.getPictureImg()
			this.userNames = this.$store.state.userNames
			if (this.userNames && Array.isArray(this.userNames) && this.userNames.length > 0) {
				this.account = this.userNames[0]
				this.password = this.Tool.generate8Password()
				let exp = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*;?:])[\da-zA-Z~!@#$%^&*;?:]{8,}$/;
				//console.log('password-1-=',this.password)
				if (!this.password || this.password.length < 8 || !exp.test(this.password)) {
					this.password = 'ty@12345'
				}
				//console.log('password-2-=',this.password)
			}
		},
		beforeDestroy() {
			this.$store.commit("changeUserNames", '')
			console.log('register-destory')
		},
		methods: {
			//切换密码显示
			switchPasswordType() {
				if (this.passwordType === 'password') {
					this.passwordType = 'text'
				} else {
					this.passwordType = 'password'
				}
			},
			// 获得焦点
			getFocus(id) {
				if (id == 1) {
					this.accountFocus = true;
				} else if (id == 2) {
					this.nameFocus = true;
				} else if (id == 3) {
					this.emailFocus = true;
				} else if (id == 4) {
					this.telFocus = true;
				} else if (id == 5) {
					this.passwordFocus = true;
				} else if (id == 6) {
					this.verifyFocus = true;
				} else if (id == 7) {
					this.codeFocus = true;
				}
			},
			// 失去焦点
			onblur(id) {
				if (id == 1) {
					this.accountFocus = false;
				} else if (id == 2) {
					this.nameFocus = false;
				} else if (id == 3) {
					this.emailFocus = false;
				} else if (id == 4) {
					this.telFocus = false;
				} else if (id == 5) {
					this.passwordFocus = false;
				} else if (id == 6) {
					this.verifyFocus = false;
				} else if (id == 7) {
					this.codeFocus = false;
				}
			},
			//获取认证图片
			getPictureImg() {
				this.verifyCode = ''
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/register/api/getPictureImg').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.verifyId = res.data.verifyId
						this.verifyImg = res.data.srcImg
					} else {
						this.verifyImg = ''
						this.$Toast("未获取到验证图片！");
					}
				}).catch((err) => {
					this.verifyImg = ''
					this.$store.dispatch(this.$LoadShow, false)
					console.log('getPictureImg', err)
				});
			},
			onPickerConfirm(value, index) {
				console.log('onPickerConfirm', value, index)
				this.accountFocus = false
				this.showSelectAccount = false
				this.account = value
			},
			onPickerChange(picker, value, index) {
				console.log('onPickerChange', value, index)
			},
			onPickerCancel() {
				this.accountFocus = false
				this.showSelectAccount = false
				console.log('onPickerCancel')
			},
			//从userNames中选择账户
			selectAccount() {
				console.log('selectAccount--=')
				if (this.userNames.length > 0) {
					this.accountFocus = true
					this.showSelectAccount = true
				}
			},
			//获取验证码
			getCode() {
				if (this.timer != 60) {
					return
				}
				this.phone = this.phone.trim()
				let reg = /^1[0-9]{10}$/;
				if (
					this.phone &&
					this.phone.length == 11 &&
					reg.test(this.phone)
				) {
					if (!this.verifyId || !this.verifyCode) {
						this.$Toast("请输入图片验证码计算结果！");
						return
					}
					this.smsCode = ''
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/register/api/sendSmsCode", JSON.stringify({
						mobile: this.phone,
						type: 0,
						verify: {
							id: this.verifyId,
							code: this.verifyCode
						},
					})).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$Toast("验证码已发送，请注意查收！");
							this.timer--;
							var timer1 = setInterval(() => {
								this.timer--;
								if (this.timer == 0) {
									this.timer = 60;
									clearTimeout(timer1);
								}
							}, 1000);
						} else {
							this.getPictureImg()
							this.$Toast(res.message || res.messageDetail || "获取验证码失败！");
						}
					}).catch(err => {
						console.log('/register/api/sendSmsCode-=', err)
						this.$store.dispatch(this.$LoadShow, false)
						this.getPictureImg()
					})
				} else {
					this.$Toast("请输入正确的手机号！");
				}
			},
			//注册成功后返回登录页
			registerBack() {
				this.$router.go(-1)
			},
			//注册核查
			registerCheck() {
				const areg = /^[a-zA-Z][a-zA-Z0-9_]*$/
				const eMailReg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$/
				const staffNameRegex = /^[\u4e00-\u9fa5\·]+$/
				this.account = this.account.trim()
				this.staffName = this.staffName.trim()
				this.email = this.email.trim()
				this.password = this.password.trim()
				this.smsCode = this.smsCode.trim()
				if (!this.account) {
					this.$Toast("请输入账户！");
					return
				}
				if (this.userNames.length === 0 && !areg.test(this.account)) {
					this.$Toast("账户名错误，必须是英文和数字组合，首字母必须为英文！");
					return
				}
				if (!this.staffName) {
					this.$Toast("请输入真实姓名！");
					return
				}
				if (!staffNameRegex.test(this.staffName)) {
					this.$Toast("真实姓名必须是中文！");
					return
				}
				if (!this.email) {
					this.$Toast("请输入邮箱！");
					return
				}
				if (!eMailReg.test(this.email)) {
					this.$Toast("请输入正确的邮箱号！");
					return
				}
				let reg = /^1[0-9]{10}$/;
				if (
					this.phone &&
					this.phone.length == 11 &&
					reg.test(this.phone)
				) {
					let exp = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*;?:])[\da-zA-Z~!@#$%^&*;?:]{8,}$/;
					if (!this.password) {
						this.$Toast("请输入密码！");
						return
					}
					if (this.password.length < 8) {
						this.$Toast("密码不能少于8位！");
						return
					}
					if (!exp.test(this.password)) {
						this.$Toast("密码需要同时包含数字、字母、特殊字符！");
						return
					}
					if (!this.smsCode) {
						this.$Toast("请输入验证码！");
						return
					}
					this.$store.dispatch(this.$LoadShow, true)
					this.$post(
						'/register/api/registerCheck',
						JSON.stringify({
							userName: this.account,
							email: this.email,
							mobile: this.phone,
							password: this.password,
							staffName: this.staffName
						})
					).then((res) => {
						if (res.success) {
							this.register()
						} else {
							this.$store.dispatch(this.$LoadShow, false)
							this.$Toast(res.message || res.messageDetail || "注册失败！");
							this.getPictureImg()
						}
					}).catch((err) => {
						this.$store.dispatch(this.$LoadShow, false)
						this.getPictureImg()
						console.log('registerCheck', err)
					})
				} else {
					this.$Toast("请输入正确的手机号！");
				}
			},
			//注册
			register() {
				this.$post(
					'/register/api/register',
					JSON.stringify({
						userName: this.account,
						email: this.email,
						mobile: this.phone,
						password: this.password,
						staffName: this.staffName,
						smsCode: this.smsCode,
					})
				).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("注册成功！");
						this.$router.go(-1)
					} else {
						this.$Toast(res.message || res.messageDetail || "注册失败！");
						this.getPictureImg()
					}
				}).catch((err) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.getPictureImg()
					console.log('register', err)
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.register_content {
		position: relative;
		padding-top: 4rem;
		height: 100%;
		background-color: white;

		::v-deep .van-cell {
			padding: 10px .3rem;
		}

	}
</style>